import React from 'react';
import Footer from '@/components/Footer';

const DataPrivacy = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <main className="flex-grow">
        <div className="container mx-auto px-4 py-24 max-w-7xl">
          <section className="mb-16">
            <h1 className="text-4xl font-bold text-black mb-4">Data Privacy</h1>
            <p className="text-base text-[#525252]">Last updated: January 15, 2025</p>
          </section>

          <section className="space-y-12">
            {/* Information We Collect */}
            <div className="pb-8 border-b border-[#E5E5E5]">
              <h2 className="text-2xl font-semibold text-black mb-6">1. Information We Collect</h2>
              <p className="text-base text-[#404040]">
                We collect information that you provide directly to us when using our energy audit services. 
                This includes personal information such as your name, email address, contact details, and 
                energy consumption data. In the next step we use this information to combine it with our own 
                data models to generate a bespoke energy consultation for you.
              </p>
            </div>

            {/* How We Use Your Information */}
            <div className="pb-8 border-b border-[#E5E5E5]">
              <h2 className="text-2xl font-semibold text-black mb-6">2. How We Use Your Information</h2>
              <ul className="list-disc pl-6 space-y-4 text-[#404040]">
                <li>To provide and maintain our energy audit services</li>
                <li>To analyze your energy consumption patterns</li>
                <li>To communicate with you about our services</li>
                <li>To comply with legal obligations</li>
              </ul>
            </div>

            {/* Data Security */}
            <div className="pb-8 border-b border-[#E5E5E5]">
              <h2 className="text-2xl font-semibold text-black mb-6">3. Data Security</h2>
              <p className="text-base text-[#404040]">
                We implement appropriate technical and organizational measures to maintain 
                the security of your personal information.
              </p>
            </div>

            {/* Your Rights */}
            <div className="pb-8 border-b border-[#E5E5E5]">
              <h2 className="text-2xl font-semibold text-black mb-6">4. Your Rights</h2>
              <p className="text-base text-[#404040]">
                You have the right to access, correct, or delete your personal information at any time. 
                Contact us at info@get-kosi.com for any privacy-related concerns.
              </p>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DataPrivacy;